import styled from 'styled-components';
import { colorScheme, zIndex } from '../../theme';

export const RowContainer = styled.div`
  cursor: pointer;

  border-bottom: 1px solid fff;
  border-left: 5px solid #white;
  transition: 300ms linear all;

  &.processed {
    border-left: 5px solid transparent;
  }

  &.unprocessed {
    border-left: 5px solid #17a2b8;
  }

  .col,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-6 {
    align-items: center;
    display: flex;
    min-height: 70px;

    &.text-center {
      justify-content: center;
    }

    &.text-right {
      justify-content: flex-end;
    }

    .row {
      display: inline-block;
      width: 100%;
      vertical-align: middle;
    }
  }

  .no-break {
    white-space: nowrap;
  }
`;

export const OuterContainer = styled.div`
  border-bottom: 1px solid ${colorScheme.divider};
  padding-bottom: 0;
  padding-top: 0;
  transition: 300ms linear background;

  &:hover {
    background: ${colorScheme.semitransparent};
  }
`;

export const HeaderRowContainer = styled.div`
  .col,
  .col-sm-1,
  .col-sm-2 {
    align-items: center;
    display: flex;
    min-height: 70px;

    &.text-center {
      justify-content: center;
    }

    &.text-left {
      justify-content: flex-start;

      &,
      .row {
        text-align: left;
      }
    }

    &.text-right {
      justify-content: flex-end;

      &,
      .row {
        text-align: right;
      }
    }

    .row {
      display: inline-block;
      text-align: center;
      width: 100%;
      vertical-align: middle;
    }
  }
`;

export const HeaderOuterContainer = styled.div`
  border-top: 1px solid ${colorScheme.globalBackground};
  font-weight: bold;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: ${zIndex.raised};

  background: ${colorScheme.globalBackground};
`;
